<script>
    export let model;
</script>

<!-- TODO: remove redundancy between this modal and the welcome dialog -->
<div id="app-modal-error">
    <div class="dialog">
        <h1>{model.statusCode}</h1>
        <h2>{model.statusText}</h2>
        <ul>
            {#each (model.result.errors || model.result.graphQLErrors) as errorObj}
                <li class="error-item">{errorObj.message}</li>
            {/each}
        </ul>
    </div>
</div>

<style>
    #app-modal-error {
        z-index: 99999999;
        background: rgba(255, 255, 255, 0.7);
        position: fixed;
        top: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dialog {
        border: 10px solid #c00;
        max-width: 600px;
        padding: 25px;
        background: white;
    }
</style>